import type { LeaveRequestState } from './leaveApi'
import type { PayrollRunState } from './payrollApi'

/**
 * Holat → rang. IKKI JOYDA ISHLATILADI (kartochka va ro'yxat sahifasi),
 * shuning uchun bitta nusxa.
 *
 * ⚠️ Ranglar tasodifiy emas: `PENDING` — SARIQ, ya'ni «amal kutmoqda»
 * (`OperationResultAlert` dagi `PARTIAL` bilan bir xil ma'no). `REJECTED`
 * qizil, `CANCELLED` esa KULRANG — ikkalasini bir rangga qo'yish «rad
 * etildi» va «o'zi qaytarib oldi» ni ajratmasdi, holbuki bu ikki BOSHQA
 * hodisa va ular haqida boshqa savol beriladi.
 */
export const LEAVE_STATE_COLOR: Record<LeaveRequestState, string> = {
  PENDING: 'gold',
  APPROVED: 'green',
  REJECTED: 'red',
  CANCELLED: 'default',
}

/**
 * Vedomost holati → rang.
 *
 * ⚠️ `APPROVED` — KO'K, `PAID` — YASHIL. Ikkalasi ham «yaxshi» holat,
 * lekin ular BOSHQA: tasdiqlangan vedomost — to'lash MAJBURIYATI,
 * to'langani esa tugagan ish. Bitta rangda ular ajralmasdi va
 * «to'ladikmi?» degan savolga ekran javob bermasdi.
 */
export const PAYROLL_STATE_COLOR: Record<PayrollRunState, string> = {
  DRAFT: 'default',
  APPROVED: 'blue',
  PAID: 'green',
  CANCELLED: 'red',
}
